import { atom, selector, RecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const seriresAtom = atom({
	key: 'serires',
	default: {
		4946: {
			ID: 4946,
			title: '보안',
			thumbnail: '/images/shapes1.webp',
			moThumbnail: '/images/seriesz_mo_1.png',
			m: '/images/m1.png',
		},
		4947: {
			ID: 4947,
			title: '화상상담',
			thumbnail: '/images/shapes2.webp',
			moThumbnail: '/images/seriesz_mo_2.png',
			m: '/images/m2.png',
		},
		4948: {
			ID: 4948,
			title: 'ESG',
			thumbnail: '/images/shapes3.webp',
			moThumbnail: '/images/seriesz_mo_3.png',
			m: '/images/m3.png',
		},
		4949: {
			ID: 4949,
			title: '솔루션',
			thumbnail: '/images/shapes4.webp',
			moThumbnail: '/images/seriesz_mo_4.png',
			m: '/images/m4.png',
		},
		4950: {
			ID: 4950,
			title: '리드앤라이트',
			thumbnail: '/images/shapes5.webp',
			moThumbnail: '/images/seriesz_mo_5.png',
			m: '/images/m5.png',
		},
		4951: {
			ID: 4951,
			title: '포켓6',
			thumbnail: '/images/shapes6.webp',
			moThumbnail: '/images/seriesz_mo_6.png',
			m: '/images/m6.png',
		},
		4966: {
			ID: 4966,
			title: '온보딩',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
		5082: {
			ID: 5082,
			title: 'TECH',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
		5034: {
			ID: 5034,
			title: '연수',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
		5013: {
			ID: 5013,
			title: '채용',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
		5008: {
			ID: 5008,
			title: '해외사업',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
	},
});

export const seriresArrayAtom = atom({
	key: 'seriresArray',
	default: [
		{
			ID: 4946,
			title: '보안',
			thumbnail: '/images/shapes1.webp',
			moThumbnail: '/images/seriesz_mo_1.png',
		},
		{
			ID: 4947,
			title: '화상상담',
			thumbnail: '/images/shapes2.webp',
			moThumbnail: '/images/seriesz_mo_2.png',
		},
		{
			ID: 4948,
			title: 'ESG',
			thumbnail: '/images/shapes3.webp',
			moThumbnail: '/images/seriesz_mo_3.png',
		},
		{
			ID: 4949,
			title: '솔루션',
			thumbnail: '/images/shapes4.webp',
			moThumbnail: '/images/seriesz_mo_4.png',
		},
		{
			ID: 4950,
			title: '리드앤라이트',
			thumbnail: '/images/shapes5.webp',
			moThumbnail: '/images/seriesz_mo_5.png',
		},
		{
			ID: 4951,
			title: '포켓6',
			thumbnail: '/images/shapes6.webp',
			moThumbnail: '/images/seriesz_mo_6.png',
		},
		{
			ID: 4966,
			title: '온보딩',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
		},
		{
			ID: 5082,
			title: 'TECH',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
		},
		{
			ID: 5034,
			title: '연수',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
		},
		{
			ID: 5013,
			title: '채용',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
		},
		{
			ID: 5008,
			title: '해외사업',
			thumbnail: '/images/shapes7.webp',
			moThumbnail: '/images/seriesz_mo_7.png',
		},
	],
});

export const seriresNumAtom = atom({
	key: 'seriresNum',
	default: '',
	effects_UNSTABLE: [persistAtom],
});

export const shuffleAtom = atom({
	key: 'shuffle',
	default: [
		{
			thumbnail: '/images/shapes1.webp',
			moThumbnail: '/images/seriesz_mo_1.png',
			m: '/images/m1.png',
		},
		{
			thumbnail: '/images/shapes2.webp',
			moThumbnail: '/images/seriesz_mo_2.png',
			m: '/images/m2.png',
		},
		{
			thumbnail: '/images/shapes3.webp',
			moThumbnail: '/images/seriesz_mo_3.png',
			m: '/images/m3.png',
		},
		{
			thumbnail: '/images/shapes4.webp',
			moThumbnail: '/images/seriesz_mo_4.png',
			m: '/images/m4.png',
		},
		{
			thumbnail: '/images/shapes5.webp',
			moThumbnail: '/images/seriesz_mo_5.png',
			m: '/images/m5.png',
		},
		{
			thumbnail: '/images/shapes6.webp',
			moThumbnail: '/images/seriesz_mo_6.png',
			m: '/images/m6.png',
		},
		{
			thumbnail: '/images/shapes7.png',
			moThumbnail: '/images/seriesz_mo_7.png',
			m: '/images/m7.png',
		},
		{
			thumbnail: '/images/shapes8.png',
			moThumbnail: '/images/seriesz_mo_8.png',
			m: '/images/m8.png',
		},
		{
			thumbnail: '/images/shapes9.png',
			moThumbnail: '/images/seriesz_mo_9.png',
			m: '/images/m9.png',
		},
		{
			thumbnail: '/images/shapes10.png',
			moThumbnail: '/images/seriesz_mo_10.png',
			m: '/images/m10.png',
		},
		{
			thumbnail: '/images/shapes1.webp',
			moThumbnail: '/images/seriesz_mo_1.png',
			m: '/images/m1.png',
		},
		{
			thumbnail: '/images/shapes2.webp',
			moThumbnail: '/images/seriesz_mo_2.png',
			m: '/images/m2.png',
		},
		{
			thumbnail: '/images/shapes3.webp',
			moThumbnail: '/images/seriesz_mo_3.png',
			m: '/images/m3.png',
		},
		{
			thumbnail: '/images/shapes4.webp',
			moThumbnail: '/images/seriesz_mo_4.png',
			m: '/images/m4.png',
		},
	],
});

function shuffle(array) {
	let currentIndex = array.length,
		randomIndex;

	// While there remain elements to shuffle.
	while (currentIndex > 0) {
		// Pick a remaining element.
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[array[currentIndex], array[randomIndex]] = [
			array[randomIndex],
			array[currentIndex],
		];
	}

	return array;
}
